module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2J9yg"))).then(() => parcelRequire('37nVf'));